import storesSlice from './storesSlice'
export default storesSlice
